import { ComponentConfig } from "@measured/puck";

import ColorPickerField from "src/components/Puck/config/fields/ColorPickerField";
import { Typography as PuckTypography, TypographyProps } from "./Typography";

export const Typography: ComponentConfig<TypographyProps> = {
    fields: {
        variant: {
            type: "select",
            label: "Text variant",
            options: [
                { label: "h1", value: "h1" },
                { label: "h2", value: "h2" },
                { label: "h3", value: "h3" },
                { label: "h4", value: "h4" },
                { label: "h5", value: "h5" },
                { label: "h6", value: "h6" },
                { label: "subtitle1", value: "subtitle1" },
                { label: "subtitle2", value: "subtitle2" },
                { label: "body1", value: "body1" },
                { label: "body2", value: "body2" },
                { label: "caption", value: "caption" },
                { label: "overline", value: "overline" },
            ],
        },
        align: {
            type: "select",
            label: "Text alignment",
            options: [
                { label: "Left", value: "left" },
                { label: "Center", value: "center" },
                { label: "Right", value: "right" },
                { label: "Justify", value: "justify" },
            ],
        },
        color: {
            type: "custom",
            label: "Text color",
            render: (props) => <ColorPickerField {...props} />,
        },
        content: {
            type: "text",
            label: "Text content - or enter an internationalization key",
        },
    },
    defaultProps: {
        variant: "body1",
        align: "left",
        color: "#000000",
        content: "Enter your text here",
        gutterBottom: true,
        noWrap: false,
    },
    render: (props) => <PuckTypography {...props} />,
};
